export const isError = (state) => state.error;
export { default as default } from './reducers';